import { useLang } from "@/contexts/LanguageContext";
import { t } from "@/translations";
import { partners } from "@/mocks/speakers";

export default function PartnersSection() {
  const { lang } = useLang();
  const tr = t[lang].partners;
  const isEn = lang === "en";

  return (
    <section className="w-full py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{tr.heading}</h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto leading-relaxed">
            {tr.subheading}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="flex flex-col gap-4 bg-[#fafafa] rounded-lg p-5 border border-gray-100"
            >
              <div className="w-full h-24 flex items-center justify-center">
                <img
                  src={partner.image}
                  alt="Partner logo"
                  className="max-h-20 max-w-full object-contain"
                />
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                {isEn ? partner.descriptionEn : partner.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
